module.exports = __webpack_public_path__ + "img/截图.4d77d2f2.png";